// Phase 2 Crypto Layer (safe wrapper)

import { getPrivateKey, savePrivateKey } from './secureKeyVault';

export async function getOrCreateKeyPairPhase2(userId: string) {
  let privateKey = await getPrivateKey(userId);

  if (privateKey) {
    return { privateKey };
  }

  const keyPair = await crypto.subtle.generateKey(
    {
      name: 'RSA-OAEP',
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: 'SHA-256',
    },
    true,
    ['encrypt', 'decrypt']
  );

  await savePrivateKey(userId, keyPair.privateKey);

  return keyPair;
}
